import React from 'react';
import PropTypes from 'prop-types';

export default function IcDate({
  className = '',
  fill = '#212121',
  height = 20,
  style = {},
  width = 18,
  ...props
}) {
  return (
    <svg
      className={className}
      fill="none"
      height={height}
      style={style}
      viewBox="0 0 18 20"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 0C13.5523 0 14 0.447715 14 1V2H15C15.7956 2 16.5585 2.3163 17.1211 2.87891C17.6837 3.44151 18 4.20435 18 5V17C18 17.7957 17.6837 18.5585 17.1211 19.1211C16.5585 19.6837 15.7957 20 15 20H3C2.20435 20 1.44152 19.6837 0.878906 19.1211C0.316297 18.5585 0 17.7956 0 17V5C0 4.20435 0.316297 3.44152 0.878906 2.87891C1.44152 2.3163 2.20435 2 3 2H4V1C4 0.447715 4.44772 0 5 0C5.55228 0 6 0.447715 6 1V2H12V1C12 0.447715 12.4477 0 13 0ZM2 17C2 17.2652 2.10543 17.5195 2.29297 17.707C2.48051 17.8946 2.73478 18 3 18H15C15.2652 18 15.5195 17.8946 15.707 17.707C15.8946 17.5195 16 17.2652 16 17V10H2V17ZM7 12C7.55228 12 8 12.4477 8 13V15C8 15.5523 7.55228 16 7 16H5C4.44772 16 4 15.5523 4 15V13C4 12.4477 4.44772 12 5 12H7ZM3 4C2.73478 4 2.4805 4.10543 2.29297 4.29297C2.10543 4.4805 2 4.73478 2 5V8H16V5C16 4.73478 15.8946 4.48051 15.707 4.29297C15.5195 4.10543 15.2652 4 15 4H14V5C14 5.55228 13.5523 6 13 6C12.4477 6 12 5.55228 12 5V4H6V5C6 5.55228 5.55228 6 5 6C4.44772 6 4 5.55228 4 5V4H3Z"
        fill={fill}
      />
    </svg>
  );
}

IcDate.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

